import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OrderStoreEffects } from './effects';
import { orderReducer } from './reducer';
import { OrderFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, orderReducer), EffectsModule.forFeature([OrderStoreEffects])],
  exports: [],
  providers: [OrderFacade],
  declarations: [],
})
export class OrderStateModule {}
